import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoadingOverlay from "../components/Loading";
import UsersList from "../components/UsersList";
import { useUser } from "../contexts/UserContext";
import styles from "../styles/modules/AdminPage.module.css";
import "../styles/sanitize.css";

function AdminPage() {
  const { memberships } = useUser();
  const navigate = useNavigate();
  const [isTenantAdmin, setIsTenantAdmin] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    // 設定は大学管理者(tenant_admin)専用。研究室・ユーザー管理のみを行う。
    const isTenantAdminResult =
      memberships?.some((item) => item.role_code === "tenant_admin") ?? false;
    setIsTenantAdmin(isTenantAdminResult);

    if (!isTenantAdminResult) {
      navigate("/labs");
    }
  }, [memberships, navigate]);

  if (!isTenantAdmin) {
    return <LoadingOverlay />;
  }

  return (
    <>
      <div className={styles["admin-page"]}>
        <h2 id="admin-title">設定</h2>
        <div>
          <UsersList onLoading={setIsLoading} />
        </div>
      </div>

      {isLoading && <LoadingOverlay />}
    </>
  );
}

export default AdminPage;
